import type { ToolCore } from "@loumy/contracts";
import { selectModel } from "@loumy/contracts";
import { Field, Select } from "../ui";
import { applyModelSwitch } from "./modelControls";

// D101 (§11): generisches Modell-Dropdown ÜBER dem Settings-Formular — registry-getrieben
// (core.models), kein Tool-Hardcoding. Es steht bewusst über den Feldern, die es steuert
// (hiddenSettings/Defaults); das `model`-Feld selbst wird aus SchemaForm/SettingsUIs
// herausgefiltert (hiddenSettingsFor), damit es nie doppelt rendert.

export function ModelPicker({
  core,
  value,
  onChange,
}: {
  core: ToolCore;
  value: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
}) {
  const models = core.models;
  if (!models || models.length === 0) return null;
  const current = selectModel(models, value);
  return (
    <Field label="Modell">
      <div className="space-y-1">
        <Select
          value={current.id}
          onChange={(e) => onChange(applyModelSwitch(models, value, e.target.value))}
          aria-label="Modell"
        >
          {models.map((m) => (
            <option key={m.id} value={m.id}>
              {m.label}
            </option>
          ))}
        </Select>
        {current.description && <p className="text-xs text-muted">{current.description}</p>}
      </div>
    </Field>
  );
}
